<!--
  <global-card-tool-tip prepend-icon="help_outline"></global-card-tool-tip>
-->
<template>
  <v-menu open-on-hover offset-x right :nudge-bottom="20" :nudge-left="16" :close-on-content-click="false" :close-on-click="true">
    <template #activator="{ on }">
      <v-icon :size="iconSize" style="cursor: pointer;" :color="iconColor" v-on="on">{{ prependIcon }}</v-icon>
    </template>
    <section class="card-body px-2 py-1" :style="`max-width:${width}`" @click="{}">
      <section class="card-text">
        <!-- @slot Contenido del card -->
        <slot name="contenido"></slot>
      </section>
    </section>
  </v-menu>
</template>

<script>
/**
 * Componente que muestra un icono on:hover para mostrar información sobre un card flotante
 */
export default {
  name: 'GlobalCardToolTip',
  props: {
    prependIcon: {
      type: String,
      default: 'help_outline'
    },
    iconColor: {
      type: String,
      default: 'gray'
    },
    width: {
      type: String,
      default: '400px'
    },
    iconSize: {
      type: String,
      default: undefined
    }
  }
}
</script>
<style scoped>
.card-body {
  background-color: #FFFFFF;
  border-width: thin;
  display: block;
  max-width: 100%;
  outline: none;
  text-decoration: none;
  transition-property: box-shadow, opacity;
  word-wrap: break-word;
  position: relative;
  white-space: normal;
}
.card-text {
  padding: 12px 16px 12px;
  width:100%;
  color: rgb(83, 83, 83);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}
</style>
